import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../../services/user.service';
import {AuthGuard} from './auth.guard';

@Injectable()
export class AdminGuard implements CanActivate {
    constructor(private userService: UserService, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return this.userService.isAdmin();
    }
}



// WEBPACK FOOTER //
// /app/src/model/Guards/admin.guard.ts